import clsx from "clsx"
import React from "react"

export const FieldGroup = ({
  row = false,
  className,
  children,
}: {
  row?: boolean
  children: React.ReactNode
  className?: string
}) => {
  return (
    <div
      className={clsx(
        "mb-4 flex flex-col gap-4",
        "md:mb-7 md:gap-6",
        {
          "md:flex-row": row,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}
